import Handlebars = require('handlebars');

Handlebars.registerHelper({

	ifIn: function(elem, list = [], options) {
		return list.indexOf(elem) >= 0
			? options.fn(this)
			: options.inverse(this)
	},

	ifInOrEmpty: function(elem, list = [], options) {
		return list.indexOf(elem) >= 0 || list.length === 0
			? options.fn(this)
			: options.inverse(this)
		;
	},

	ifInAndOnly: function(elem, list = [], options) {
		return list.indexOf(elem) >= 0 && list.length === 1
			? options.fn(this)
			: options.inverse(this)
		;
	},

	ifEqual: function(a, b, options) {
		return (a === b)
			? options.fn(this)
			: options.inverse(this)
		;
	},

	ifContains: function(str, substr, options) {
		return str?.indexOf(substr) >= 0
			? options.fn(this)
			: options.inverse(this)
		;
	},

	list: function(str) {
		return str.toString().split(',').join(', ');
	},

	sentenceCase: function(str = '') {
		const pattern = /\b([a-z])[a-z]*\b/g;
		const transform = letter => letter.toUpperCase();
		return str.replace(pattern, transform);
	},

	lowerCase: function(str = '') {
		const pattern = /\b([A-Z])[a-z]*\b/g;
		const transform = letter => letter.toLowerCase();
		return str.replace(pattern, transform);
	},

	simplePluralize: function(str = '') {
		if (str.toLowerCase == 'software') return str;
		if (/s$/.test(str)) return str;
		return str + 's';
	}

});

export { Handlebars };
